import React from 'react';
import Chatbotui from '../../components/chatbotui/chatbotui';

const ChatPage = () => {
    return (
        <main className="chat-page-container"> 
            <Chatbotui /> 
        </main>
    );
};

export default ChatPage;
